/**
 * Development-only logger utility
 *
 * Use this instead of console.log to prevent logging in production.
 * Errors are always logged regardless of environment.
 */

const isDev = import.meta.env.DEV;

export const devLog = {
  /**
   * Log messages only in development
   */
  log: (...args: unknown[]): void => {
    if (isDev) {
      console.log(...args);
    }
  },

  /**
   * Log info messages only in development
   */
  info: (...args: unknown[]): void => {
    if (isDev) {
      console.info(...args);
    }
  },

  /**
   * Log warnings only in development
   */
  warn: (...args: unknown[]): void => {
    if (isDev) {
      console.warn(...args);
    }
  },

  /**
   * Log errors always (production and development)
   * Errors should always be logged for debugging
   */
  error: (...args: unknown[]): void => {
    console.error(...args);
  },

  /**
   * Log debug messages only in development
   */
  debug: (...args: unknown[]): void => {
    if (isDev) {
      console.debug(...args);
    }
  },

  /**
   * Group logs only in development
   */
  group: (label: string): void => {
    if (isDev) {
      console.group(label);
    }
  },

  /**
   * End group only in development
   */
  groupEnd: (): void => {
    if (isDev) {
      console.groupEnd();
    }
  },

  /**
   * Table logs only in development
   */
  table: (data: unknown): void => {
    if (isDev) {
      console.table(data);
    }
  },
};

export default devLog;
